import { render } from "./AppPopup.vue?vue&type=template&id=13e44488&scoped=true"
import script from "./AppPopup.vue?vue&type=script&lang=js"
export * from "./AppPopup.vue?vue&type=script&lang=js"

import "./AppPopup.vue?vue&type=style&index=0&id=13e44488&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13e44488"]])

export default __exports__